module.exports = __webpack_public_path__ + "15b9ccd6171f2b1c9acb98c925027af6.png";